import { Component, OnInit } from '@angular/core';
import { FascicoloAnonimo, ParteAnonima } from '../../models/ricerca-anonima-dto';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';

@Component({
  selector: 'app-consultazione-anonima-fascicolo-modal',
  templateUrl: './consultazione-anonima-fascicolo-modal.component.html',
  styleUrls: ['./consultazione-anonima-fascicolo-modal.component.css']
})
export class ConsultazioneAnonimaFascicoloModalComponent implements OnInit {
  fascicolo: FascicoloAnonimo;

  constructor(
    private dialogConfig: DialogConfig
  ){}

  ngOnInit(){
    this.fascicolo = this.dialogConfig.data.fascicoloAnonimo;
  }

  replaceNull (value) {
      return !!value && value != '' ? value : '-';
  }

  getNominativo(parte: ParteAnonima) {
    if(!!parte.nome){
      if(!!parte.cognome){
        return parte.nome + " " + parte.cognome;
      } else return parte.nome;
    } else {
      if(parte.cognome){
        return parte.cognome;
      } else {
        return "-";
      }
    }
  }

}
